import React, { useState } from 'react';
import Sidebar from '../Components/Sidebar';
import { TfiHandPointRight } from "react-icons/tfi";
import './Elevation.css'; // Reuse existing styles

const Mep = () => {
  const [zoomImage, setZoomImage] = useState(null);

  // 10 MEP sample images from /public/gallery/mep/mep_1.jpg to mep_10.jpg
  const mepImages = Array.from({ length: 10 }, (_, i) => `/gallery/mep/mep_${i + 1}.jpg`);

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />

      <div className="elevation-content">
        <h1 className="service-title">MEP DRAWING</h1>

        {/* Main hero image */}
        <div className="service-image">
          <img src="/gallery/mep/mep_3.jpg" alt="MEP Drawing" />
        </div>

        <h3>Why Choose Our Draftsman Services?</h3>
        <ul className="draftsman-points">
          <li><TfiHandPointRight /> Accurate and detailed MEP (Mechanical, Electrical, Plumbing) plans</li>
          <li><TfiHandPointRight /> Expert layout design for HVAC, lighting, water, and drainage systems</li>
          <li><TfiHandPointRight /> AutoCAD & Revit supported MEP drafting</li>
          <li><TfiHandPointRight /> Efficient space utilization and compliance with building codes</li>
        </ul>

        {/* Image Grid Section */}
        <div className="image-grid-section">
          <h2>Gallery of MEP Samples</h2>
          <div className="image-grid">
            {mepImages.map((src, index) => (
              <div
                className="grid-image-box"
                key={index}
                onClick={() => setZoomImage(src)}
              >
                <img src={src} alt={`MEP Sample ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        {/* Contact Section */}
        <div className="service-contact">
          <h2>Contact Us for More Information</h2>
          <p>If you have any questions or would like to discuss your project, please contact us:</p>
          <ul>
            <li>Email: <a href="mailto:blessedandblessed247@gmail.com">blessedandblessed247@gmail.com</a></li>
            <li>Phone: <a href="tel:+231770508020">+231 770-508-020</a>, <a href="tel:+919908526058">+91 99085 26058</a></li>
          </ul>
        </div>
      </div>

      {/* Zoom Modal */}
      {zoomImage && (
        <div className="image-modal" onClick={() => setZoomImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={() => setZoomImage(null)}>❌</span>
            <img src={zoomImage} alt="Zoomed View" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Mep;
